<template>
<div class="main list-view no-sidebar template-manager">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @keyup.enter="getList()" v-focus>
			<div class="button action input-go" @click="getList()"><i class="fas fa-search"></i></div>
		</div>
	</div>

	<loading v-if="loading" class="main-content"></loading>

	<div v-else-if="showNewTemplates" class="new-templates">
		<div class="section-heading">Choose a Layout Starting Point</div>
		<div style="grid-column-start: 3; display: grid; grid-template-columns: 1fr 1fr; grid-gap: 1em;">
			<button class="cancel" @click="newTemplate()"><i class="fa fa-chevron-left"></i> Back</button>&nbsp;
			<button :class="['primary', { disabled: !newTemplateLayout } ]" @click="newTemplate('color')">Next <i class="fa fa-chevron-right"></i></button>
		</div>
		<p>This will help you get started with your new template. You'll be able to change things around a little later.</p>
		<div :class="['template-picker', { selected: newTemplateLayout == 1 }]" @click="newTemplateLayout = 1">
			<img src="/dashboard/img/new-template-1.jpg">
		</div>
		<div :class="['template-picker', { selected: newTemplateLayout == 2 }]" @click="newTemplateLayout = 2">
			<img src="/dashboard/img/new-template-2.jpg">
		</div>
		<div :class="['template-picker', { selected: newTemplateLayout == 3 }]" @click="newTemplateLayout = 3">
			<img src="/dashboard/img/new-template-3.jpg">
		</div>
	</div>

	<div v-else-if="showNewTemplateColors" class="new-templates">
		<div class="section-heading">Choose a Color Theme Starting Point</div>
		<div style="grid-column-start: 3; display: grid; grid-template-columns: 1fr 1fr; grid-gap: 1em;">
			<button class="cancel" @click="newTemplate('layout')"><i class="fa fa-chevron-left"></i> Back</button>&nbsp;
			<button :class="['primary', { disabled: !newTemplateLayoutColor } ]" @click="newTemplate('name')">Next <i class="fa fa-chevron-right"></i></button>
		</div>
		<p>This will help you get started with your new template colors.  You'll be able to change things around a little later.</p>
		<div :class="['template-picker', { selected: newTemplateLayoutColor == 'black' }]" @click="newTemplateLayoutColor = 'black'">
			<img :src="'/dashboard/img/new-template-' + newTemplateLayout + '.jpg'">
			<div class="color-overlay black"></div>
		</div>
		<div :class="['template-picker', { selected: newTemplateLayoutColor == 'gold' }]" @click="newTemplateLayoutColor = 'gold'">
			<img :src="'/dashboard/img/new-template-' + newTemplateLayout + '.jpg'">
			<div class="color-overlay gold"></div>
		</div>
		<div :class="['template-picker', { selected: newTemplateLayoutColor == 'red' }]" @click="newTemplateLayoutColor = 'red'">
			<img :src="'/dashboard/img/new-template-' + newTemplateLayout + '.jpg'">
			<div class="color-overlay red"></div>
		</div>
		<div :class="['template-picker', { selected: newTemplateLayoutColor == 'green' }]" @click="newTemplateLayoutColor = 'green'">
			<img :src="'/dashboard/img/new-template-' + newTemplateLayout + '.jpg'">
			<div class="color-overlay green"></div>
		</div>
		<div :class="['template-picker', { selected: newTemplateLayoutColor == 'blue' }]" @click="newTemplateLayoutColor = 'blue'">
			<img :src="'/dashboard/img/new-template-' + newTemplateLayout + '.jpg'">
			<div class="color-overlay blue"></div>
		</div>
		<div :class="['template-picker', { selected: newTemplateLayoutColor == 'brown' }]" @click="newTemplateLayoutColor = 'brown'">
			<img :src="'/dashboard/img/new-template-' + newTemplateLayout + '.jpg'">
			<div class="color-overlay brown"></div>
		</div>
		<div :class="['template-picker', { selected: newTemplateLayoutColor == 'orange' }]" @click="newTemplateLayoutColor = 'orange'">
			<img :src="'/dashboard/img/new-template-' + newTemplateLayout + '.jpg'">
			<div class="color-overlay orange"></div>
		</div>
	</div>

	<div v-else-if="showNewTemplateName" class="new-templates">
		<div class="section-heading">Give your new template a name</div>
		<div style="grid-column-start: 3; display: grid; grid-template-columns: 1fr 1fr; grid-gap: 1em;">
			<button class="cancel" @click="newTemplate('color')"><i class="fa fa-chevron-left"></i> Back</button>&nbsp;
			<button :class="['primary', { disabled: !newTemplateName } ]" @click="saveNewTemplate()">Save <i class="fa fa-chevron-right"></i></button>
		</div>
		<p>This will help you identify your template as you continue to work on it.</p>
		<p style="grid-column: 1/3; margin: 0.5em 0;"><input type="text" v-model="newTemplateName" placeholder="Template name"></p>
		<button style="grid-column-start: 1;" :class="['primary', { disabled: !newTemplateName } ]" @click="saveNewTemplate()">Save New Template</button>
		<div style="padding: 1em 0 11em;">{{ message }}</div>
	</div>

	<div v-else class="list">

		<div v-if="!getAdministratorFlag" style="float: left; margin: 0 2em 0 0;">
			<div class="section-heading">{{ autoPilotEnabled ? 'Auto Pilot' : 'Published' }} Template</div>
			<div class="template-list">
				<div class="template-tile" @click="toggleShowControls(published_template.template_id)">
                    <img :src="published_template.image_src" v-if="published_template.template_type_code != 'WEBSITE_BUILDER'">
					<template-preview-thumbnail :templateData="published_template.template_data" v-else></template-preview-thumbnail>
					<div class="description">{{ published_template.description }}</div>
					<div v-if="showControlsId == published_template.template_id" class="template-tile-controls">
						<button v-if="published_template.client_id == clientId" class="primary" @click="editTemplate(published_template)">Edit</button>
						<div v-else class="empty-controls">Published</div>
					</div>
				</div>
			</div>
		</div>

		<div v-if="!getAdministratorFlag" class="section-heading">Your Templates</div>
		<div v-if="!getAdministratorFlag" class="template-list">
			<div class="template-tile" @click="newTemplate('layout')">
				<img src="/dashboard/img/new-template.jpg">
				<div class="description">Create a New Template</div>
				<div class="template-tile-controls">
					<div class="empty-controls">New<br><i class="fa fa-plus"></i></div>
				</div>
			</div>
			<div v-for="template in custom_templates" class="template-tile" @click="toggleShowControls(template.template_id)" :key="template.template_id">
				<template-preview-thumbnail :templateData="template.template_data"></template-preview-thumbnail>
				<div class="description">{{ template.description }}</div>
				<div v-if="showControlsId == template.template_id" class="template-tile-controls">
					<button class="primary" @click="editTemplate(template)">Edit</button>
					<button class="primary" @click="previewTemplate(template.template_id)">Preview</button>
					<button v-if="!autoPilotEnabled" class="primary" @click="confirmPublish(template.template_id)">Publish</button>
					<button class="delete" @click="confirmDelete(template.template_id)">Delete</button>
				</div>
			</div>

		</div>

		<div v-if="!getAdministratorFlag" class="section-divider"></div>

		<div class="section-heading">Template Library</div>
		<div class="template-list">
			<div v-for="template in templates" class="template-tile" @click="toggleShowControls(template.template_id)" :key="template.template_id">
				<template-preview-thumbnail :templateData="template.template_data"></template-preview-thumbnail>
				<div class="description">{{ template.description }}</div>
				<div v-if="showControlsId == template.template_id" class="template-tile-controls">
					<button class="primary" @click="editTemplate(template)">Edit</button>
					<button class="primary" @click="previewTemplate(template.template_id)">Preview</button>
				</div>
			</div>
		</div>

	</div>

	<div v-if="showModal" class="modal">
		<div class="inner">
			<h2>Confirm {{ modalFor }}</h2>
			<div class="content">
				{{ modalPrompt }}
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showModal = false">Cancel</div>
				<div class="button action spaced" @click="doModal()">Yes, {{ modalFor }}</div>
			</div>
		</div>
	</div>

	<div v-if="showWarning" class="modal">
		<div class="inner">
			<h2 style="color:red">Warning</h2>
			<div class="content">
				{{ warningPrompt }}
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showWarning = false">I understand</div>
			</div>
		</div>
	</div>

	<help-popup :helpLink="{92:'Website Templates', 359:'Adding Content to Your Website', 94:'New Custom Template'}" :tours="false"></help-popup>

</div>
</template>

<script>
import TemplatePreviewThumbnail from '../components/TemplatePreviewThumbnail'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'menus',
	components: {
		'template-preview-thumbnail': TemplatePreviewThumbnail,
		'help-popup': HelpPopup
	},
	data() {
		return {
			loading: false,
			filters: {
				search_term: ''
			},
			paging: {},
			message: '',
			clientId: '',
			templates: [],
			custom_templates: [],
			legacy_templates: [],
			published_template: [],
			showControlsId: '',
			showNewTemplates: false,
			newTemplateLayout: '',
			showNewTemplateColors: false,
			newTemplateLayoutColor: '',
			showNewTemplateName: '',
			newTemplateName: '',
			startNewTemplate: false,
			templateId: '',
			showModal: false,
			modalFor: '',
			modalPrompt: '',
			autoPilotEnabled: false,
			warningPrompt: '',
			showWarning: false
		}
	},
	created() {
		this.getAutoPilotEnabled()
		this.getList()
	},
	watch: {
        "filters.search_term"(newVal) {
            if (!newVal) {
				this.getList()
            }
        }
	},
	methods: {
		getAutoPilotEnabled() {
			this.apiCall({ destination: 'get_item_preference', data: { preference_code: 'ENABLE_AUTO_PILOT' } }).then(obj => {
				this.autoPilotEnabled = obj.ENABLE_AUTO_PILOT != ''
			}).catch(err => {
				console.log(err)
			})
		},
		getList() {
			if (this.getAdministratorFlag) {
				this.getSystemList()
				return
			}
            this.loading = true
			this.newTemplate() // clears any new template picker process
			this.apiCall({ destination: 'get_list_client_templates', data: this.filters }).then(obj => {
				this.loading = false
				this.custom_templates = obj.custom_templates
				this.published_template = obj.published_template
				this.clientId = obj.client_id
				this.getSystemList()
				this.systemTemplateWarning()
			}).catch(err => {
                this.loading = false
				console.log(err)
			})
		},
		getSystemList() {
            this.loading = true
			this.apiCall({ destination: 'get_list_system_templates', data: this.filters }).then(obj => {
				this.loading = false
				this.templates = obj.templates
			}).catch(err => {
                this.loading = false
				console.log(err)
			})
		},
		toggleShowControls(templateId) {
			if (this.showControlsId == templateId) {
				this.showControlsId = ''
			} else {
				this.showControlsId = templateId
			}
		},
		newTemplate(which) {
			switch (which) {
				case 'layout':
					this.showNewTemplateName = false
					this.showNewTemplateColors = false
					this.showNewTemplates = true
					break;
				case 'color':
					if (this.newTemplateLayout) {
						this.showNewTemplateName = false
						this.showNewTemplates = false
						this.showNewTemplateColors = true
					}
					break;
				case 'name':
					if (this.newTemplateLayoutColor) {
						this.showNewTemplates = false
						this.showNewTemplateColors = false
						this.showNewTemplateName = true
					}
					break;
				default:
					this.showNewTemplateName = false
					this.showNewTemplateColors = false
					this.showNewTemplates = false
			}
		},
		saveNewTemplate() {
			this.apiCall({ destination: 'save_item_new_template', data: { layout: this.newTemplateLayout, colors: this.newTemplateLayoutColor, description: this.newTemplateName } }).then(obj => {
				if (obj.status == 'success') {
					this.$router.push({ path: '/website/template-manager/' + obj.template_id })
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		editTemplate(template) {
			if (template.client_id == this.clientId) {
				this.$router.push({ path: '/website/template-manager/' + template.template_id })
			} else {
				// copy system template to dealer, then edit
				this.apiCall({ destination: 'save_item_copy_template', data: { template_id: template.template_id } }).then(obj => {
					if (obj.status == 'success' && obj.template_id) {
						this.$router.push({ path: '/website/template-manager/' + obj.template_id })
					} else {
						this.message = obj.message
					}
				}).catch(err => {
					console.log(err)
				})
			}
		},
		confirmDelete(templateId) {
			this.templateId = templateId
			this.modalFor = 'Delete'
			this.modalPrompt = 'Are you sure you want to delete this custom template?'
			this.showModal = true
		},
		confirmPublish(templateId) {
			this.templateId = templateId
			this.modalFor = 'Publish'
			this.modalPrompt = "Are you sure you're ready to publish this template?"
			this.showModal = true
		},
		doModal() {
			let apiDestination = this.modalFor == 'Delete' ? 'delete_item_template' : 'publish_item_template'
			this.apiCall({ destination: apiDestination, data: { template_id: this.templateId } }).then(obj => {
				if (obj.status == 'success') {
					this.getList()
					this.showModal = false
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		previewTemplate(templateId) {
			let previewURL
			if (window.location.hostname.indexOf('.test') > -1) {
				previewURL = 'https://cdsfrontend.test:8081/frontend/?template_id=' + templateId
			} else {
				previewURL = window.location.origin + '/' + "?template_id=" + templateId
			}
			var previewWindow = window.open(previewURL, "_blank")
		},
		systemTemplateWarning() {
			if (!this.autoPilotEnabled && this.published_template.client_id != this.clientId) {
				this.warningPrompt = 'You currently have an Auto Pilot template published while Auto Pilot is disabled. Select one of your templates or a template from your library to allow edits.'
				this.showWarning = true
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.template-list {
	display: grid;
	grid-template-columns: repeat(auto-fill, 200px);
	grid-gap: 2em;
}
.template-tile {
	position: relative;
	cursor: pointer;
	text-align: center;
	img { display: block; width: 100%; }
	border: 1px solid #ccc;
	.description {
		background-color: #999;
		color: white;
		font-size: 0.8em;
		padding: 0.5em;
	}

}

button.delete { background: #6b6b6b; }
.template-tile-controls {
	position: absolute;
	width: 100%;
	height: calc(100% - 1.75em);
	top: 0; left: 0;
	background-color: rgba(255,255,255,0.75);
	padding: 1em;
	button { width: 100%; margin: 0 0 0.5em 0; }
	.empty-controls { font-size: 1.75em; margin: 2em 0 0 0; text-transform: uppercase; }
}
.new-templates {
	margin: 1em;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-column-gap: 1em;
	p {
		grid-column: 1/4;
		margin: 0.5em 0 3em 0;
	}
	button { display: inline-block; }
	img { display: block; width: 100%; }
	.template-picker {
		margin: 0 2em 2em 0;
		border: 1px solid #cecece;
		display: inline-block;
		//max-width: 30%;
		position: relative;
	}
	.template-picker.selected { border: 3px solid red; }
	.color-overlay {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}
	.red { background-color: rgba(166, 5, 0, 0.6); }
	.brown { background-color: rgba(125, 74, 18, 0.6); }
	.orange { background-color: rgba(255, 145, 4, 0.6); }
	.green { background-color: rgba(39, 76, 1, 0.6); }
	.blue { background-color: rgba(0, 49, 111, 0.6); }
	.gold { background-color: rgba(204, 152, 0, 0.6); }
	.black { background-color: rgba(0, 0, 0, 0.6); }
}
</style>
